import { render, staticRenderFns } from "./im-readstatus-view-group.vue?vue&type=template&id=087c7b82"
import script from "./im-readstatus-view-group.vue?vue&type=script&lang=js"
export * from "./im-readstatus-view-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('087c7b82')) {
      api.createRecord('087c7b82', component.options)
    } else {
      api.reload('087c7b82', component.options)
    }
    module.hot.accept("./im-readstatus-view-group.vue?vue&type=template&id=087c7b82", function () {
      api.rerender('087c7b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/group/im-readstatus-view-group.vue"
export default component.exports